import React, { useContext } from 'react'
import cx from 'classnames'
import PlaceholderImage from '@softwaredev_cegeka/stix-core/dist/components/PlaceholderImage'
import ThemeContext from '@softwaredev_cegeka/stix-core/dist/components/ThemeProvider/ThemeContext'
import { reverse } from 'src/routes/config'
import useTranslations from 'src/hooks/useTranslations'
import halfLogoSvg from 'src/assets/images/logo mark_half.svg'
import styles from 'src/routes/ErrorPages/errorpage.module.scss'
import { pushGtmDataLayer } from 'src/utils/gtm'

export default function NotFound(props) {
    const { activeTheme } = useContext(ThemeContext)
    // We don't receive props.t here because this isn't rendered in a ContentRoute
    const { t } = useTranslations('not-found', 'not-found')
    pushGtmDataLayer({
        event: 'pageNotFound',
        pagePath: props.location.pathname,
    })

    if (props.location.pathname !== reverse('not-found')) {
        window.location.href = reverse('not-found')
    }

    return (
        <div className={cx('page-body', 'error-page', styles.notFoundWrapper)}>
            <div className={styles.contentWrapper}>
                <div className={styles.textWrapper}>
                    <h1>{t('Ooops...')}</h1>
                    <h2>{t('Page not found')}</h2>
                    <h3>
                        {t('This page does not exist or was removed.')}
                        <br />
                        {t('We suggest you go back to home.')}
                    </h3>
                </div>
                <PlaceholderImage
                    src={activeTheme?.config?.notFoundLogo ?? halfLogoSvg}
                    className={styles.halfLogo}
                    alt=""
                />
            </div>
        </div>
    )
}
